var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLogoVirtikBig(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 344,
    height: 86,
    viewBox: "0 0 344 86",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1427_48619)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M149.908 27.7393L142.632 44.4542L145.428 50.9689L155.55 27.7393H149.908Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M139.708 51.1799L129.591 27.7393H123.473L136.755 58.1248H142.31L142.5 57.6905L139.708 51.1799Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M170.922 27.7393H165.28V58.1248H170.922V27.7393Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M219.544 32.5126H229.616V58.1248H235.258V32.5126H245.33V27.7393H219.544V32.5126Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M261.738 27.7393H256.096V58.1248H261.738V27.7393Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M282.13 27.6797H276.459V58.2182H282.13V27.6797Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M306.375 27.7532H299.612L285.61 42.9542L285.618 42.9625L285.598 42.9832L298.445 58.3124H304.898L292.191 43.1527L306.375 27.7532Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M211.076 38.5475C211.076 31.8177 206.129 27.7393 198.138 27.7393H185.634V58.1248H191.276V32.5126H197.873C202.82 32.5126 205.385 34.7255 205.385 38.5475C205.385 42.3695 202.824 44.6238 197.873 44.6238H196.297L205.583 58.1248H211.593L204.603 48.1397C208.727 46.5348 211.072 43.1471 211.072 38.5475H211.076Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M102.773 28.0215L109.697 18.9712H95.2072L88.2871 28.0215L73.5493 47.698L80.792 57.3729L102.773 28.0215Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M81.1434 18.9713H51.8871L37.625 18.963L46.4561 30.8757L58.8113 30.8839L72.0558 30.9625L81.1434 18.9713Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M80.791 57.3728L73.5483 47.698L61.0152 30.9127H46.5256L66.3055 57.3728L73.5483 67.0436L80.791 57.3728Z",
    fill: "url(#paint0_linear_1427_48619)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1427_48619",
    x1: 75.8646,
    y1: 59.6271,
    x2: 53.2058,
    y2: 31.5125,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.69,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#508EEB"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1427_48619"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 268.75,
    height: 48.0807,
    fill: "white",
    transform: "translate(37.625 18.9595)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoVirtikBig);
export default __webpack_public_path__ + "static/media/logo_virtik_big.454eff11fb3240fae87ed32c144aabbc.svg";
export { ForwardRef as ReactComponent };